
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { EditableTabs } from "@/types/views";
import { Userinfo } from "@/types/store";

/** 右键菜单状态 */
interface ContextMenuState {
  visible: boolean;
  tabName: string;
  style: { left: string; top: string };
}

@Component({ name: 'layout-components-Content' })
export default class Submenu extends Vue {
  @Prop() descripbeName!: string;
  @Prop() editableTabsValue!: string;
  @Prop() isCollapse!: boolean;
  @Prop() editableTabs!: Array<EditableTabs>;
  @Prop({ default: () => [] }) cachedViews!: string[];

  /** 右键菜单状态 */
  contextMenu: ContextMenuState = {
    visible: false,
    tabName: "",
    style: { left: "0px", top: "0px" },
  };

  created() {
    // 点击页面其他区域关闭右键菜单
    document.addEventListener("click", this.closeContextMenu);
  }

  beforeDestroy() {
    document.removeEventListener("click", this.closeContextMenu);
  }

  // ========== 右键菜单逻辑 ==========

  /** 右键点击 tab，提取 tab name 并显示菜单 */
  onTabContextmenu(e: MouseEvent) {
    const target = e.target as HTMLElement;
    // el-tab-pane 渲染为 .el-tabs__item，name 存储在 id 属性中
    const tabItem = target.closest("[role='tab']");
    if (!tabItem) return;

    const tabName = tabItem.id?.replace("tab-", "") || "";
    if (!tabName) return;

    this.contextMenu.tabName = tabName;
    this.contextMenu.style = { left: e.clientX + "px", top: e.clientY + "px" };
    this.contextMenu.visible = true;
  }

  closeContextMenu() {
    this.contextMenu.visible = false;
  }

  /** 当前右键的 tab 在列表中的索引 */
  get contextTabIndex(): number {
    return this.editableTabs.findIndex(t => t.name === this.contextMenu.tabName);
  }

  /** 是否可以关闭左侧（右键 tab 不是第一个，且左侧有非首页 tab） */
  get canCloseLeft(): boolean {
    return this.contextTabIndex > 0;
  }

  /** 是否可以关闭右侧 */
  get canCloseRight(): boolean {
    return this.contextTabIndex >= 0 && this.contextTabIndex < this.editableTabs.length - 1;
  }

  /** 是否可以关闭其他（至少有 2 个 tab） */
  get canCloseOther(): boolean {
    return this.editableTabs.length > 1;
  }

  /** 菜单项点击，emit 对应事件给父组件 */
  onMenuAction(action: "close-left" | "close-right" | "close-other") {
    const tabName = this.contextMenu.tabName;
    this.closeContextMenu();
    this.$emit(action, tabName);
  }

  // ========== 原有逻辑 ==========

  @Watch('isCollapse')
  setCollapse(){
    this.$store.dispatch('setCollapse',this.isCollapse)
  }

  get userinfo(): Userinfo {
    return this.$store.getters.userinfo;
  }
  get loading() {
    return this.$store.getters.loading;
  }
}
